import {
  ACCESS_LOGS_ICON,
  ADMIN_ICON,
  ANALYTICS_ICON,
  PERMISSIONS_ICON,
  PROJECTS_ICON,
  USER_MANAGEMENT_ICON,
  type NavigationItem,
} from '../components/layout/navigation-items';
import type { Capability } from '../types';
import { ROUTES } from './routes';

export interface AdminSection extends NavigationItem {
  readonly description: string;
  /** Capability the section's endpoints require; null for the dashboard. */
  readonly capability: Capability | null;
  /** False until the section's API exists (`docs/api.md` §5). */
  readonly isAvailable: boolean;
}

/**
 * The admin area's sections, in navigation order. The shell's tab bar and the
 * dashboard's cards both read this list, so they cannot disagree.
 */
export const ADMIN_SECTIONS: readonly AdminSection[] = [
  {
    to: ROUTES.admin.index,
    label: 'Dashboard',
    icon: ADMIN_ICON,
    end: true,
    description: 'Overview of the administration area.',
    capability: null,
    isAvailable: true,
  },
  {
    to: ROUTES.admin.users,
    label: 'Users',
    icon: USER_MANAGEMENT_ICON,
    description: 'Add people, assign roles and deactivate access.',
    capability: 'users:manage',
    isAvailable: true,
  },
  {
    to: ROUTES.admin.projects,
    label: 'Projects',
    icon: PROJECTS_ICON,
    description: 'Create, edit and archive catalogue records.',
    capability: 'projects:manage',
    isAvailable: true,
  },
  {
    to: ROUTES.admin.permissions,
    label: 'Permissions',
    icon: PERMISSIONS_ICON,
    description: 'Choose which projects each user can open.',
    capability: 'grants:manage',
    isAvailable: true,
  },
  {
    to: ROUTES.admin.accessLogs,
    label: 'Access Logs',
    icon: ACCESS_LOGS_ICON,
    description: 'Every project open, allowed or denied.',
    capability: 'access-logs:read',
    isAvailable: true,
  },
  {
    to: ROUTES.admin.analytics,
    label: 'Analytics',
    icon: ANALYTICS_ICON,
    description: 'Sessions, active users and estimated active time.',
    capability: 'access-logs:read',
    isAvailable: true,
  },
];

export function adminSectionFor(to: string): AdminSection | undefined {
  return ADMIN_SECTIONS.find((section) => section.to === to);
}
